define('ch_facebook',['optional!facebook'], function() {
    if (typeof FB === 'undefined') return;

    FB.init({
        appId      : CH.FB.appId,       // App ID
        channelUrl : CH.FB.channelUrl,  // Channel File
        status     : true,              // check login status
        cookie     : true,              // enable cookies to allow the server to access the session
        xfbml      : true,              // parse XFBML
        version    : 'v2.12'
    });
});

